module.exports = __webpack_public_path__ + "img/Icon-survey-locked.13a84206.svg";